import {
	Table, Popconfirm, Pagination, Checkbox
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import {
	reCharacteristicActions
}from './store/actions'
import moment from "moment"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'

import ReCharacteristicChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import ModalAudit from '../ModalAudit'

const ReCharacteristic = ({ isModify = false }) => {
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [auditVisible, setAuditVisible] = useState(false)
	const [audit, setAudit] = useState(null)
	const [record, setRecord] = useState(null)
	const [page, setPage] = useState(1)
	const [search, setSearch] = useState(null)

	const { isSending, changed, paged, pagedAudit } = useSelector((state) => state.reCharacteristicReducer)

	const [searchValue] = useDebounce(search, 500)
	const dispatch = useDispatch()

	const columns = [
		{
			dataIndex : 'code',
			inputType : 'text',
			key       : 'code',
			title     : 'Код'

		},
		{
			dataIndex : 'name',
			inputType : 'text',
			key       : 'name',
			title     : 'Наименование',
			width     : "40%"
		},

		{
			dataIndex : 'isSelect',
			inputType : 'bool',
			key       : 'isSelect',
			title     : 'Выбор из возможных вариантов',
			width     : "5%",
			align     : "center",
			render    : checked => (
				<Checkbox
					checked={ checked }
				/>
			  )
		},
		{
			dataIndex : 'type',
			inputType : 'bool',
			key       : 'type',
			title     : 'Тип',
			render    : type => (type === 1 ? "Текст" : type === 2 ? "Число" : null)
		},
		{
			dataIndex : 'measurementUnit',
			inputType : 'text',
			key       : 'measurementUnit',
			title     : 'Единица измерения'
		},
		{
			dataIndex : 'deviation',
			inputType : 'text',
			key       : 'deviation',
			title     : 'Соответствие',
			render    : deviation => (deviation === 1 ? "Отсутствует" : deviation === 2 ? "Полное" : "Частичное")
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	const columnsAudit = [
		{
			dataIndex : "action",
			key       : "action",
			title     : "Действие"
		},
		{
			dataIndex : 'code',
			inputType : 'text',
			key       : 'code',
			title     : 'Код'

		},
		{
			dataIndex : 'name',
			inputType : 'text',
			key       : 'name',
			title     : 'Наименование',
			width     : "40%"
		},

		{
			dataIndex : 'isSelect',
			inputType : 'bool',
			key       : 'isSelect',
			title     : 'Выбор из возможных вариантов',
			width     : "5%",
			align     : "center",
			render    : checked => (
				<Checkbox
					checked={ checked }
				/>
			  )
		},
		{
			dataIndex : 'type',
			inputType : 'bool',
			key       : 'type',
			title     : 'Тип',
			render    : type => (type === 1 ? "Текст" : type === 2 ? "Число" : null)
		},
		{
			dataIndex : 'measurementUnit',
			inputType : 'text',
			key       : 'measurementUnit',
			title     : 'Единица измерения'
		},
		{
			dataIndex : 'deviation',
			inputType : 'text',
			key       : 'deviation',
			title     : 'Соответствие',
			render    : deviation => (deviation === 1 ? "Отсутствует" : deviation === 2 ? "Полное" : "Частичное")
		},
		{
			key       : "actionDateTime",
			title     : "Дата изменения",
			dataIndex : "actionDateTime"
		},
		{
			title     : "IP-адрес",
			key       : "ip",
			dataIndex : "ip"
		}
	]

	const getPaged = params => {
		dispatch(reCharacteristicActions.getPaged(params))
	}
	const getPagedAll = params => {
		dispatch(reCharacteristicActions.getPagedAll(params))
	}
	const getPagedAudit = (params) => {
		dispatch(reCharacteristicActions.getPagedAudit(params))
	}
	const create = params => {
		dispatch(reCharacteristicActions.create(params))
	}
	const remove = params => {
		dispatch(reCharacteristicActions.remove(params))
	}
	const update = params => {
		dispatch(reCharacteristicActions.update(params))
	}
	const restore = params => {
		dispatch(reCharacteristicActions.restore(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reCharacteristicActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
		}
	}, [changed])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchValue])

	useEffect(() => {
		onPaginationAuditChange(1)
	}, [audit])

	function onPaginationChange(value){
		setPage(value)
		const params = {
			name     : searchValue?.trim(),
			pageSize : pageSize,
			page     : value
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	function onPaginationAuditChange(value){
		if (audit){
			getPagedAudit({
				id   : audit,
				page : value,
				pageSize
			})
		}
	}

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : 100,
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon :RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setAuditVisible(true)
							setAudit(record.id)
						} }
					/>
				</div>
			)
		})
		: null

	return (
		<>
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 64 }
					placeholder="Введите название/код"
					onChange={ (e) => setSearch(e.target.value) }
				/>
				{ isModify
					? (
						<CustomButton
							className="add-nsi"
							type="green"
							onClick={ () => {
								setRecord(null)
								setVisible(true)
							} }
						>
							<div>
								<img src={ AddIcon } />
								<span>
                                    Добавить
								</span>
							</div>
						</CustomButton>
					)
					: null }
			</div>
			<Table
				columns={ columns }
				dataSource={ paged?.items }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1100 } }
			/>
			{
				paged?.count > pageSize &&
                    <Pagination
                    	showQuickJumper
                    	current={ page }
                    	pageSize={ pageSize }
                    	showSizeChanger={ false }
                    	size="small"
                    	total={ paged.count }
                    	onChange={ onPaginationChange }
                    />
			}
			{ isModify &&
			<>
				<ReCharacteristicChangeForm
                    	create={ create }
                    	record={ record }
                    	setRecord={ setRecord }
                    	setVisible={ setVisible }
                    	update={ update }
                    	visible={ visible }
				/>
				<ModalAudit
					columns={ columnsAudit }
					count={ pagedAudit.count }
					data={ pagedAudit.items }
					setIdRecordAudit={ setAudit }
					setPage={ onPaginationAuditChange }
					setVisible={ setAuditVisible }
					visible={ auditVisible }
				/>
			</> }
		</>
	)
}

export default ReCharacteristic
